let groupByImpl: typeof Object.groupBy | undefined;

export function groupBy<K extends PropertyKey, T>(
  items: Iterable<T>,
  keySelector: (item: T, index: number) => K
): Record<K, T[]> {
  return <Record<K, T[]>>groupByImpl!(items, keySelector);
}

export async function setGroupByImpl(
  impl?: typeof Object.groupBy
): Promise<void> {
  if (groupByImpl) {
    return;
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/groupBy
  if (impl) {
    groupByImpl = impl;
  } else if (typeof Object.groupBy === 'function') {
    groupByImpl = Object.groupBy;
  } else {
    groupByImpl = (await import('./lodash-groupby')).groupBy;
  }

  // eslint-disable-next-line no-restricted-globals
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-restricted-globals
    window.groupByImpl = groupByImpl;
  }
}
